import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface Notice {
  id: string
  branchCode: SystemCode
  displayBranchCode: SystemCode
  displayPlaceCode: SystemCode
  displayStartDate: string
  displayEndDate: string
  body: string
  registeredDate: string
  revision: number
}

export const defaultNotice = (): Notice => ({
  id: '',
  branchCode: defaultSystemCode(),
  displayBranchCode: defaultSystemCode(),
  displayPlaceCode: defaultSystemCode(),
  displayStartDate: '',
  displayEndDate: '',
  body: '',
  registeredDate: '',
  revision: 0
})

export function NoticeFromJSON(json: any): Notice {
  return {
    id: exists(json, 'id') ? json.id : '',
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    displayBranchCode: exists(json, 'display_branch_code')
      ? SystemCodeFromJSON(json.display_branch_code)
      : defaultSystemCode(),
    displayPlaceCode: exists(json, 'display_place_code')
      ? SystemCodeFromJSON(json.display_place_code)
      : defaultSystemCode(),
    displayStartDate: exists(json, 'display_start_date')
      ? dateToPlainFormat(json.display_start_date)
      : '',
    displayEndDate: exists(json, 'display_end_date')
      ? dateToPlainFormat(json.display_end_date)
      : '',
    body: exists(json, 'body') ? json.body : '',
    registeredDate: exists(json, 'registered_date')
      ? dateToPlainFormat(json.registered_date)
      : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
